<template>
  <div
    @click="scroll"
    class="scroll-chevron"
  >
    <transition mode="out-in" name="message">
      <p
        v-if="conditionals"
        class="scroll-message"
      >
        Scroll om verder te gaan
      </p>
    </transition>
    <svg
      class="chevron"
      xmlns="http://www.w3.org/2000/svg"
      width="27.414"
      height="8.021"
    >
      <path
        d="M25.914 1.5L13.707 6.521 1.5 1.5"
        fill="none"
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="3"
      />
    </svg>
  </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto'

export default {
  name: 'ScrollChevron',
  props: {
    scrollTo: {
      type: String,
      required: true
    },
    conditionals: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    scroll () {
      VueScrollTo.scrollTo(this.scrollTo, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.message-enter-active,
.message-leave-active {
  transition: all 1600ms cubic-bezier(0.19, 1, 0.22, 1);
  transition-property: opacity, transform;
  will-change: opacity, transform;
}

.message-leave-active {
  transition-duration: 400ms;
}

.message-enter,
.message-leave-to {
  opacity: 0;
}

.message-enter {
  transform: translateY(-25px);
}

.message-leave-to {
  transform: translateY(25px);
}

.scroll-message {
  color: white;
  font-size: 14px;
  font-weight: $fw-medium;
  line-height: 17px;
  position: absolute;
  bottom: 30px;
  left: 0;
  right: 0;
  margin: 0 auto;
  cursor: pointer;
}

.chevron {
  margin: 0 auto;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: pointer;
}
</style>
